<div
  class="slider-component__item"
  tabindex="0"
  [attr.aria-label]="item.title"
  [class.selected-item]="active"
>
  <div class="item__img cover-img__list" (click)="onClicked()">
    <opac-record-cover
      [isList]="!!item.covers || item.concatenatedCovers"
      [coverUrl]="item.covers[0]">
    </opac-record-cover>
  </div>

  <div class="item__info">
    <p [innerHTML]="item.title"></p>
  </div>
</div>
